import React from 'react';
import { Modal } from '../../ui/Modal';
import { Badge } from '../../ui/Badge';
import { DetailField } from './DetailField';
import { formatEuro } from '../../../utils/currency';
import { formatCourseDate } from '../../../utils/trainingCourses';
import { OnDemandEnrollment } from '../../../types/trainingCourse';
interface EnrollmentDetailModalProps {
  enrollment: OnDemandEnrollment | null;
  onClose: () => void;
}
export function formatStamp(iso?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  return `${d.toLocaleDateString('it-IT')} alle ${d.toLocaleTimeString('it-IT', {
    hour: '2-digit',
    minute: '2-digit'
  })}`;
}
export function EnrollmentDetailModal({
  enrollment,
  onClose
}: EnrollmentDetailModalProps) {
  return <Modal isOpen={Boolean(enrollment)} onClose={onClose} title="Dettaglio partecipante" size="lg" data-id="element-1288" data-mp="1ijfhw4hsgru6">
      {enrollment && <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5" data-id="element-1289" data-mp="2b22uevipyyjn">
          <DetailField label="Nome" data-id="element-1290" data-mp="e1u170l26cpy">{enrollment.firstName}</DetailField>
          <DetailField label="Cognome" data-id="element-1291" data-mp="e23rkpa0mlw6">{enrollment.lastName}</DetailField>
          <DetailField label="Email personale" data-id="element-1292" data-mp="a1jvlp16hobm">{enrollment.email}</DetailField>
          <DetailField label="Iscrizione" data-id="element-1293" data-mp="nrx3xshzf51h">{formatCourseDate(enrollment.enrolledAt)}</DetailField>
          <DetailField label="Importo di acquisto" data-id="element-1294" data-mp="j0f5pc7cfik7">{formatEuro(enrollment.price)}</DetailField>
          <DetailField label="Corso completato" data-id="element-1295" data-mp="xpbi1lgfnhqm">{enrollment.completed ? 'Sì' : 'No'}</DetailField>
          <DetailField label="Credenziali" data-id="element-1296" data-mp="sr9qsd8usc42">
            <Badge variant={enrollment.credentialsSentAt ? 'success' : 'warning'} size="sm" data-id="element-1297" data-mp="sqgr1w8bamvf">
              {enrollment.credentialsSentAt ? 'Inviate' : 'Da inviare'}
            </Badge>
            {enrollment.credentialsSentAt && <span className="block text-xs text-slate-500 mt-1" data-id="element-1298" data-mp="38hw9xwfgv41g">
                {formatStamp(enrollment.credentialsSentAt)}
              </span>}
          </DetailField>
          <DetailField label="Attestato" data-id="element-1299" data-mp="33l5tv93nw8g1">
            <Badge variant={enrollment.certificateSentAt ? 'success' : 'warning'} size="sm" data-id="element-1300" data-mp="17gga8ahpmlbb">
              {enrollment.certificateSentAt ? 'Inviato' : 'Da inviare'}
            </Badge>
            {enrollment.certificateSentAt && <span className="block text-xs text-slate-500 mt-1" data-id="element-1301" data-mp="1hc9l7pfs66qz">
                {formatStamp(enrollment.certificateSentAt)}
              </span>}
          </DetailField>
        </dl>}
    </Modal>;
}